'use client';

import { useQuery } from '@tanstack/react-query';
import { lookupInvitation } from './invitations';

export function useInvitationLookup(token: string | null, withSession = true) {
  return useQuery({
    queryKey: ['households', 'invitation', token, withSession],
    queryFn: () => lookupInvitation(token as string, { withSession }),
    enabled: !!token,
    retry: false,
    // Each lookup spends the per-IP quota, so returning to the tab does not repeat it.
    refetchOnWindowFocus: false,
  });
}
